import { Laya } from "../../../Laya";
import { BaseRender2DType, BaseRenderNode2D } from "../../NodeRender2D/BaseRenderNode2D";
import { RenderManager2D } from "../../NodeRender2D/RenderManager2D";
import { BufferUsage } from "../../RenderEngine/RenderEnum/BufferTargetType";
import { DrawType } from "../../RenderEngine/RenderEnum/DrawType";
import { MeshTopology } from "../../RenderEngine/RenderEnum/RenderPologyMode";
import { LayaGL } from "../../layagl/LayaGL";
import { FastSinglelist } from "../../utils/SingletonList";
import { SpineShaderInit } from "../material/SpineShaderInit";
export class SpineInstanceBatch {
    constructor() {
        this._recoverList = new FastSinglelist();
    }
    check(left, right) {
        if (left.materialShaderData != right.materialShaderData
            || left.geometry.instanceCount
            || right.geometry.instanceCount)
            return false;
        return true;
    }
    batchRenderElement(list, start, length) {
        let elementArray = list.elements;
        let batchStart = -1;
        for (let i = 0; i < length - 1; i++) {
            let index = start + i;
            let cElement = elementArray[index];
            let nElement = elementArray[index + 1];
            if (this.check(cElement, nElement)) {
                if (batchStart == -1) {
                    batchStart = i;
                }
            }
            else {
                if (batchStart != -1) {
                    this.batch(list, batchStart + start, i - batchStart);
                }
                batchStart = 0;
            }
        }
        if (batchStart != -1) {
            this.batch(list, batchStart + start, length - batchStart);
        }
    }
    updateBuffer(info, nMatrixData, simpleAnimatorData, instanceCount) {
        let nMatrixInstanceVB = info.nMatrixInstanceVB;
        let simpleAnimatorVB = info.simpleAnimatorVB;
        nMatrixInstanceVB.setData(nMatrixData.buffer, 0, 0, instanceCount * 6 * 4);
        simpleAnimatorVB.setData(simpleAnimatorData.buffer, 0, 0, instanceCount * 4 * 4);
    }
    batch(list, start, length) {
        let instanceElement, geometry;
        let elementArray = list.elements;
        let nMatrixData = SpineInstanceElement2DTool._instanceBufferCreate(6 * SpineInstanceElement2DTool.MaxInstanceCount);
        let simpleAnimatorData = SpineInstanceElement2DTool._instanceBufferCreate(4 * SpineInstanceElement2DTool.MaxInstanceCount);
        let state, info;
        let instanceCount = 0;
        for (let i = 0; i < length; i++) {
            let element = elementArray[start + i];
            let shaderData = element.value2DShaderData;
            if (!instanceElement) {
                let originGeo = element.geometry;
                info = SpineInstanceElement2DTool.getInstanceInfo(originGeo);
                instanceElement = info.element;
                this._recoverList.add(info);
                geometry = instanceElement.geometry;
                instanceCount = geometry.instanceCount = 0;
                instanceElement.subShader = element.subShader;
                instanceElement.materialShaderData = element.materialShaderData;
                instanceElement.value2DShaderData = element.value2DShaderData;
                instanceElement.renderStateIsBySprite = element.renderStateIsBySprite;
                instanceElement.nodeCommonMap = element.nodeCommonMap;
                instanceElement.value2DShaderData.addDefine(SpineShaderInit.SPINE_GPU_INSTANCE);
            }
            let nMatrix_0 = shaderData.getVector3(BaseRenderNode2D.NMATRIX_0);
            let nMatrix_1 = shaderData.getVector3(BaseRenderNode2D.NMATRIX_1);
            let nMatrixOffset = instanceCount * 6;
            nMatrixData[nMatrixOffset] = nMatrix_0.x;
            nMatrixData[nMatrixOffset + 1] = nMatrix_0.y;
            nMatrixData[nMatrixOffset + 2] = nMatrix_0.z;
            nMatrixData[nMatrixOffset + 3] = nMatrix_1.x;
            nMatrixData[nMatrixOffset + 4] = nMatrix_1.y;
            nMatrixData[nMatrixOffset + 5] = nMatrix_1.z;
            let simpleAnimatorParams = shaderData.getVector(SpineShaderInit.SIMPLE_SIMPLEANIMATORPARAMS);
            let offset = instanceCount * 4;
            simpleAnimatorData[offset] = simpleAnimatorParams.x;
            simpleAnimatorData[offset + 1] = simpleAnimatorParams.y;
            simpleAnimatorData[offset + 2] = simpleAnimatorParams.z;
            simpleAnimatorData[offset + 3] = simpleAnimatorParams.w;
            instanceCount++;
            geometry.instanceCount = instanceCount;
            if (geometry.instanceCount == SpineInstanceElement2DTool.MaxInstanceCount) {
                this.updateBuffer(info, nMatrixData, simpleAnimatorData, geometry.instanceCount);
                list.add(instanceElement);
                instanceElement = null;
            }
        }
        if (instanceElement) {
            this.updateBuffer(info, nMatrixData, simpleAnimatorData, geometry.instanceCount);
            list.add(instanceElement);
        }
        SpineInstanceElement2DTool._instanceBufferRecover(nMatrixData);
        SpineInstanceElement2DTool._instanceBufferRecover(simpleAnimatorData);
    }
    recover() {
        let length = this._recoverList.length;
        let recoverArray = this._recoverList.elements;
        for (let i = 0; i < length; i++) {
            let info = recoverArray[i];
            SpineInstanceElement2DTool.recover(info);
        }
        this._recoverList.length = 0;
    }
}
Laya.addAfterInitCallback(function () {
    SpineInstanceBatch.instance = new SpineInstanceBatch;
    RenderManager2D.regisBatch(BaseRender2DType.spineSimple, SpineInstanceBatch.instance);
});
export class SpineInstanceElement2DTool {
    static getInstanceInfo(geometry) {
        let infos = SpineInstanceElement2DTool._instanceBufferInfoMap.get(geometry);
        if (!infos) {
            infos = [];
            SpineInstanceElement2DTool._instanceBufferInfoMap.set(geometry, infos);
        }
        let info = infos.pop() || SpineInstanceElement2DTool.createInstanceInfo(geometry);
        return info;
    }
    static createInstanceInfo(geometry) {
        let element = LayaGL.render2DRenderPassFactory.createRenderElement2D();
        let instanceGeometry = element.geometry = LayaGL.renderDeviceFactory.createRenderGeometryElement(MeshTopology.Triangles, DrawType.DrawElementInstance);
        let state = LayaGL.renderDeviceFactory.createBufferState();
        let info = { state, element, source: geometry };
        let oriBufferState = geometry.bufferState;
        let vertexArray = oriBufferState._vertexBuffers.slice();
        let nMatrixInstanceVB = LayaGL.renderDeviceFactory.createVertexBuffer(BufferUsage.Dynamic);
        nMatrixInstanceVB.setDataLength(SpineInstanceElement2DTool.MaxInstanceCount * 16 * 4);
        nMatrixInstanceVB.vertexDeclaration = SpineShaderInit.instanceNMatrixDeclaration;
        nMatrixInstanceVB.instanceBuffer = true;
        vertexArray.push(nMatrixInstanceVB);
        info.nMatrixInstanceVB = nMatrixInstanceVB;
        let simpleAnimatorVB = LayaGL.renderDeviceFactory.createVertexBuffer(BufferUsage.Dynamic);
        simpleAnimatorVB.setDataLength(SpineInstanceElement2DTool.MaxInstanceCount * 4 * 4);
        simpleAnimatorVB.vertexDeclaration = SpineShaderInit.instanceSimpleAnimatorDeclaration;
        simpleAnimatorVB.instanceBuffer = true;
        vertexArray.push(simpleAnimatorVB);
        info.simpleAnimatorVB = simpleAnimatorVB;
        state.applyState(vertexArray, geometry.bufferState._bindedIndexBuffer);
        instanceGeometry.drawParams.elements = geometry.drawParams.elements.slice();
        instanceGeometry.drawParams.length = geometry.drawParams.length;
        instanceGeometry.indexFormat = geometry.indexFormat;
        instanceGeometry.bufferState = state;
        return info;
    }
    static recover(info) {
        let element = info.element;
        element.value2DShaderData.removeDefine(SpineShaderInit.SPINE_GPU_INSTANCE);
        element.value2DShaderData = null;
        element.materialShaderData = null;
        element.subShader = null;
        element.nodeCommonMap = null;
        let infos = SpineInstanceElement2DTool._instanceBufferInfoMap.get(info.source);
        infos.push(info);
    }
    static _instanceBufferCreate(length) {
        let array = SpineInstanceElement2DTool._bufferPool[length];
        if (!array) {
            array = SpineInstanceElement2DTool._bufferPool[length] = [];
        }
        let element = array.pop() || new Float32Array(length);
        return element;
    }
    static _instanceBufferRecover(float32) {
        let length = float32.length;
        let array = SpineInstanceElement2DTool._bufferPool[length];
        if (!array) {
            array = SpineInstanceElement2DTool._bufferPool[length] = [];
        }
        array.push(float32);
    }
}
SpineInstanceElement2DTool.MaxInstanceCount = 2048;
SpineInstanceElement2DTool._instanceBufferInfoMap = new Map;
SpineInstanceElement2DTool._pool = [];
SpineInstanceElement2DTool._bufferPool = [];
